import { maxWidth, minWidth, noTouch } from '@/assets/styles/mixins.css'
import { loadableStyles } from '@/assets/styles/global.css'
import vars from '@/assets/styles/vars'
import styled from 'styled-components'

const SearchResult = styled.article`
  --common-transition-time: 0.3s;

  position: relative;
  display: flex;
  min-height: 180px;
  z-index: 0;
  transition: z-index 0s var(--common-transition-time);

  ${loadableStyles}

  ${noTouch()`
    &:hover {
      z-index: 1;
      transition: z-index 0s;
    }
  `}
`

SearchResult.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

SearchResult.Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0 0 0 1px var(--color-border);
  transition: transform var(--common-transition-time) ease-in,
    box-shadow 0s var(--common-transition-time);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06), 0px 0px 4px rgba(0, 0, 0, 0.04);
    opacity: 0;
    transition: opacity var(--common-transition-time) ease-in;
  }

  ${minWidth(vars.breakpoints.mobile + 1)`
    ${noTouch()`
      ${SearchResult}:hover & {
        transform: scale(1.02);
        box-shadow: none;
        transition: transform var(--common-transition-time) ease-in,
          box-shadow var(--common-transition-time);

        &:after {
          opacity: 1;
        }
      }
    `}
  `}
`

SearchResult.Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  min-height: 100%;
  padding: 28px 32px 36px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 22px 20px 26px;
  `}
`

SearchResult.Tag = styled.p`
  margin-bottom: 22px;
  padding-right: 40px;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-extra);

  ${maxWidth(vars.breakpoints.tablet - 1)`
    padding-right: 30px;
  `}
`

SearchResult.Title = styled.h3`
  margin-bottom: 8px;
  margin-top: auto;
  font-weight: normal;
  font-size: 20px;
  line-height: 1.4;
  color: var(--color-main);
`

SearchResult.Description = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-extra);
`

SearchResult.Arrow = styled.div`
  --arrow-btn-width: 56px;
  --arrow-btn-shadow-content: none;

  position: absolute;
  top: 18px;
  right: 14px;
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity var(--common-transition-time) ease-in,
    transform var(--common-transition-time) ease-in;

  ${maxWidth(vars.breakpoints.sDesktop)`
    --arrow-btn-width: 46px;
    top: 16px;
    right: 16px;
  `}

  ${maxWidth(vars.breakpoints.tablet - 1)`
    --arrow-btn-width: 60px;
    --arrow-btn-bg: rgba(0, 0, 0, 0);
    --arrow-btn-color: var(--color-decor);
    top: 0
    right: 0;
    opacity: 1;
    transform: none;
  `}

  ${noTouch()`
    ${SearchResult}:hover & {
      opacity: 1;
      transform: none;
    }
  `}
`

export default SearchResult
